class TourRoute extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('load', this.initSlider.bind(this));
  }

  initSlider() {
    const sliderEl = this.querySelector('.tour-route__slider');
    if(!sliderEl) return;

    this.slider = new Swiper(sliderEl, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3
        }
      },
      navigation: {
        prevEl: '.tour-route-slider__button.prev',
        nextEl: '.tour-route-slider__button.next'
      }
    });
  }
}

if(!customElements.get('tour-route')) {
  customElements.define('tour-route', TourRoute);
}